import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withProps, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';

import MailchimpIntegrationOutlet from './MailchimpIntegrationOutlet';
import withNotifications from '../../../../common/withNotifications';
import { BRAND_USER_BASE_URL } from '../../../../constants';
import withRedirectToIntegration from './withRedirectToIntegration';
import withMailchimpConnectionSave from './withMailchimpConnectionSave';
import IntegrationSpinner from '../IntegrationSpinner';

const mapStateToProps = state => ({
  mailchimpConnectionState: state.mailchimp.mailchimpConnectionState,
});

export default compose(
  connect(mapStateToProps, null),
  withRouter,
  withProps(() => ({
    baseUrl: BRAND_USER_BASE_URL,
  })),
  withRedirectToIntegration,
  withNotifications,
  withMailchimpConnectionSave,
  withPropsOnChange(['mailchimpConnectionState'], (props) => {
    props.redirectToIntegration(props.baseUrl, `/mailchimp/${props.mailchimpConnectionState}`);
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchSettings(this.props.brandId);
    },
  }),
  branch(
    props => !props.mailchimpConnectionState,
    renderComponent(IntegrationSpinner)
  )
)(MailchimpIntegrationOutlet);
